'use strict';

module.exports = {
    /**
     * 拍照或从手机相册中选图接口
     * @method hysdk.chooseImage
     * @category Fusion:Image
     * @description
     *  支持 count 参数，其他参数各方定制。
     */
    chooseImage: {
        service: 'Util',
        action: 'choosePhoto',
        tagname: 'choose_photo',
        optHandle: function optHandle(opt) {
            if (opt.count) {
                opt.maxPhotoCount = opt.count;
            }
            return opt;
        },
        resHandle: function resHandle(res) {
            return {
                localIds: res.imagePathList,
                thumbnails: res.thumbnails
            };
        }
    },
    uploadImage: false,
    previewImage: false,
    downloadImage: false
};


//////////////////
// WEBPACK FOOTER
// ../plugins/ctrip/apis/image.js
// module id = 46
// module chunks = 1 4